export default class MerchEmbed {
    private static readonly TRUSTED_ORIGINS = [
        'https://www.merchpp.cz',
        'https://merchpp.cz',
        'https://app.merchpp.orb.local',
    ];

    static init(): void {
        const iframe = document.querySelector<HTMLIFrameElement>('.merch-embed iframe');

        if (!iframe) {
            return;
        }

        window.addEventListener('message', (e: MessageEvent) => {
            if (!this.TRUSTED_ORIGINS.includes(e.origin) || e.source !== iframe.contentWindow) {
                return;
            }

            const height = typeof e.data === 'object' && e.data !== null ? e.data.height : undefined;

            if (typeof height === 'number' && height > 0) {
                iframe.style.height = `${height}px`;
            }
        });
    }
}
